module.exports = __webpack_public_path__ + "img/dimers-bright-yellow.2c243cb4.png";